import RfxViewTabs from "./RfxViewTabs";

export default RfxViewTabs;
